import React, {ReactElement} from "react"

const RouteIcon = ({disabled}: {disabled?: boolean}): ReactElement => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M31.1327 35.0278L19.6357 30.8045C16.4663 29.6402 16.0472 25.3284 18.9332 23.5756V23.5756C21.9521 21.7421 21.3204 17.1882 17.9164 16.2457L12.7135 14.805"
        stroke={disabled ? "#7E8591" : "url(#paint0_linear_1051_59056)"}
        strokeWidth="5.2093"
        strokeLinecap="round"
        strokeOpacity={disabled ? 0.37 : 1}
      />
			<path
				d="M10.2117 12.0002C10.7203 12.523 10.9746 12.7843 11.2768 12.8844C11.5381 12.9708 11.834 12.9708 12.0953 12.8844C12.3975 12.7843 12.6518 12.523 13.1604 12.0002C14.6612 10.4577 15.8721 8.95083 15.8721 7.19048C15.8721 4.87614 13.9979 3 11.686 3C9.37416 3 7.5 4.87614 7.5 7.19048C7.5 8.95083 8.71094 10.4577 10.2117 12.0002Z"
        fill={disabled ? "#7E8591" : "url(#paint1_linear_1051_59056)"}
        fillOpacity={disabled ? 0.37 : 1}
      />
			<path
				d="M31.8787 33.1667C32.3873 33.6895 32.6416 33.9508 32.9438 34.0509C33.2051 34.1373 33.501 34.1373 33.7623 34.0509C34.0645 33.9508 34.3188 33.6895 34.8274 33.1667C36.3282 31.6242 37.5391 30.1173 37.5391 28.357C37.5391 26.0426 35.6649 24.1665 33.353 24.1665C31.0411 24.1665 29.167 26.0426 29.167 28.357C29.167 30.1173 30.3779 31.6242 31.8787 33.1667Z"
        fill={disabled ? "#7E8591" : "url(#paint3_linear_1051_59056)"}
        fillOpacity={disabled ? 0.37 : 1}
      />
			<defs>
				<linearGradient id="paint0_linear_1051_59056" x1="10.7747" y1="16.0182" x2="31.4796" y2="36.1144"
				                gradientUnits="userSpaceOnUse">
					<stop offset="0.0306724" stopColor="#3B9CF1"/>
					<stop offset="1" stopColor="#22578B"/>
				</linearGradient>
				<linearGradient id="paint1_linear_1051_59056" x1="10.8565" y1="4.96429" x2="12.1809" y2="15.7642"
				                gradientUnits="userSpaceOnUse">
					<stop stopColor="#53AFF0"/>
					<stop offset="1" stopColor="#095588"/>
				</linearGradient>
				<linearGradient id="paint3_linear_1051_59056" x1="32.5235" y1="26.1308" x2="33.8479" y2="36.9307"
				                gradientUnits="userSpaceOnUse">
					<stop stopColor="#53AFF0"/>
					<stop offset="1" stopColor="#095588"/>
				</linearGradient>
			</defs>
		</svg>
	)
}

export default RouteIcon
